import { render } from "./ReceivedFileView.vue?vue&type=template&id=8e5c4f96&scoped=true"
import script from "./ReceivedFileView.vue?vue&type=script&lang=js"
export * from "./ReceivedFileView.vue?vue&type=script&lang=js"

import "./ReceivedFileView.vue?vue&type=style&index=0&id=8e5c4f96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5c4f96"]])

export default __exports__